import React from "react";
import ServiceLocation from "../FormComponent/servicelocation";

const ServiceLocationSection = ({
  orgProfileUIData,
  zipLocData,
  locationNames,
  fetchServiceLocData,
  fetchZipData,
  addOrRemoveServiceLocNames,
}) => (
  <div className="form-row mb__18">
    <label className="gridEven col-md-3">Service Location</label>
    <span className="gridOdd col-md-9 formGroup">
      <ServiceLocation
        serviceLocData={orgProfileUIData?.ServiceLocations ?? {}}
        selectedCountry={orgProfileUIData?.OrgCountry}
        zipLocData={zipLocData}
        locationNames={locationNames}
        fetchServiceLocData={fetchServiceLocData}
        removeServiceLocNames={(data) =>
          addOrRemoveServiceLocNames({
            data: data.length > 0 ? data : [],
          })
        }
        addServiceLocationKey={(data) =>
          addOrRemoveServiceLocNames({ data: data })
        }
        fetchZipData={fetchZipData}
      />
    </span>
  </div>
);

export default ServiceLocationSection;
